(function () {
  // Paint colour swatches from the option value. Case-sensitive on purpose, the
  // same escape hatch the other stores use: an option named "Colour" becomes
  // swatches, "COLOUR" stays a plain text pill.
  var SWATCH_OPTIONS = ['Color', 'Colour'];

  function showSelected(fieldset, legend) {
    if (!legend) return;
    // Remember the bare option name once, so repainting never stacks values.
    if (!legend.dataset.optionName) legend.dataset.optionName = legend.textContent.trim().split(':')[0].trim();
    var checked = fieldset.querySelector('input[type="radio"]:checked');
    var value = checked ? (checked.value || '').trim() : '';
    var wanted = legend.dataset.optionName + (value ? ': ' + value : '');
    if (legend.textContent.trim() !== wanted) legend.textContent = wanted;
  }

  function paint() {
    document.querySelectorAll('.product-form__input--pill').forEach(function (fieldset) {
      var legend = fieldset.querySelector('legend');
      var name = legend ? legend.textContent.trim().split(':')[0].trim() : '';
      // The option literally named "quantity" is a tier picker, not a colour:
      // tag it so CSS can hide the legend and run the pills full width.
      if (name.toLowerCase() === 'quantity') { fieldset.classList.add('is-quantity-option'); return; }

      // Dawn's legend is just the option name; show what is actually selected
      // beside it, the way the old theme did ("Colour: Blue & Black").
      showSelected(fieldset, legend);

      if (SWATCH_OPTIONS.indexOf(name) === -1) return;

      fieldset.querySelectorAll('input[type="radio"]').forEach(function (input) {
        var label = fieldset.querySelector('label[for="' + (window.CSS && CSS.escape ? CSS.escape(input.id) : input.id) + '"]');
        if (!label || label.classList.contains('color-swatch')) return;
        var value = (input.value || '').trim();
        label.classList.add('color-swatch');
        label.setAttribute('title', value);
        // "Dark green" is not a colour CSS can read; closing the gap makes it one.
        // Anything still unreadable falls back to the neutral chip in custom.css.
        label.style.backgroundColor = value.toLowerCase().replace(/\s+/g, '');
      });
    });
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; paint(); });
  }

  function start() {
    paint();
    // Dawn re-renders the picker on every variant change.
    var root = document.querySelector('.product__info-container') || document.body;
    new MutationObserver(schedule).observe(root, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
